import React, { Component } from 'react'
import Select from 'react-select'
import 'react-select/dist/react-select.css';

export default class Selector extends Component {

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.options.length !== this.props.options.length ||
            nextProps.options.value !== this.props.value
    }

    render() {

        const { title, onChange, options, value, label, mode } = this.props
        return <div style={{ display: 'flex', alignSelf: 'stretch', marginTop: 20 }} >
            <p style={{ marginRight: 20, marginTop: 6 }} > {title} </p>
            <Select style={{ width: mode === 1 ? 538 : 420 }} placeholder={label ? label : 'ชื่อหน่วยงาน'} onChange={onChange} options={options} value={value} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Regular/Select.js